import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { BimEmpty } from './BimEmpty';
import { useScript } from '@/shared/hooks';
const bindSceneAction = (ref, bimSceneRef) => {
    const editor = bimSceneRef.current;
    if (!editor) {
        throw new Error('找不到 bimSceneRef');
    }
    const actionTyping = {
        getPublishData: () => {
            return editor.getPublishData();
        },
    };
    ref.current = actionTyping;
};
const BimScene = ({ style, viewToken, getResourceListHandler, getViewTokenHandler, actionRef: propsActionRef, }) => {
    const bimSceneRef = useRef();
    useEffect(() => {
        const loaderConfig = new BimfaceSDKLoaderConfig();
        loaderConfig.viewToken = viewToken;
        BimfaceSDKLoader.load(loaderConfig, (viewMetaData) => {
            const domShow = document.getElementById('bimSceneId');
            const editorConfig = new Glodon.Bimface.Module.Scene.EditorConfig();
            editorConfig.domElement = domShow;
            editorConfig.viewToken = viewToken;
            if (getResourceListHandler) {
                editorConfig.getResourceListHandler = getResourceListHandler;
            }
            if (getViewTokenHandler) {
                editorConfig.getViewTokenHandler = getViewTokenHandler;
            }
            const editor = new Glodon.Bimface.Module.Scene.Editor(editorConfig);
            bimSceneRef.current = editor;
            if (propsActionRef) {
                // @ts-ignore
                bindSceneAction(propsActionRef, bimSceneRef);
            }
        }, (e) => {
            console.log('failure_load:', e);
        });
        return () => {
            if (bimSceneRef.current) {
                bimSceneRef.current?.destroy();
            }
        };
    }, [getResourceListHandler, getViewTokenHandler, propsActionRef, viewToken]);
    useImperativeHandle(propsActionRef, () => bimSceneRef.current);
    return _jsx("div", { id: "bimSceneId", style: style });
};
export const BimfaceScene = (props) => {
    const status = useScript('https://static.bimface.com/api/BimfaceSDKLoader/BimfaceSDKLoader@latest-release.js');
    return useMemo(() => {
        return _jsx(_Fragment, { children: status === 'ready' ? _jsx(BimScene, { ...props }) : BimEmpty });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.viewToken, status]);
};
